import { isEmpty, isNull } from 'lodash'

import constants from 'constants/index'

const { PENDING_STATUS, OVERDUE_STATUS } = constants.suppliers.companySuppliers

const quizQuestionTemplateStatus = (quizQuestionTemplate, companySupplier) => {
  if (
    companySupplier?.remainingDays < 0 &&
    isNull(quizQuestionTemplate?.status)
  )
    return OVERDUE_STATUS

  return quizQuestionTemplate?.status || PENDING_STATUS
}

const getSiblingQuestions = (
  companySupplierQuestionnaires,
  companySupplierQuestionnaireId,
  currentQuizQuestionTemplateId,
) => {
  if (isEmpty(companySupplierQuestionnaires)) {
    return { previousQuestion: null, nextQuestion: null }
  }

  const questionnaire = companySupplierQuestionnaires.find(
    (item) => String(item.id) === String(companySupplierQuestionnaireId),
  )

  const quizQuestionTemplates = questionnaire?.quizQuestionTemplates || []

  const currentIndex = quizQuestionTemplates.findIndex(
    (item) => String(item.id) === String(currentQuizQuestionTemplateId),
  )

  if (currentIndex === -1) {
    return { previousQuestion: null, nextQuestion: null }
  }

  return {
    previousQuestion: quizQuestionTemplates[currentIndex - 1] || null,
    nextQuestion: quizQuestionTemplates[currentIndex + 1] || null,
  }
}

const companySuppliers = { quizQuestionTemplateStatus, getSiblingQuestions }

export default companySuppliers
